export const OFFER_TEST_IDS = {
    OFFER_VIEW: {
        // Lead / register / phone (header & modals)
        OPEN_LEAD_FORM_HEADING: "open-lead-form-heading-button",
        OPEN_LEAD_FORM_DEVELOPER_BOX: "open-lead-form-developer-button",
        OPEN_LEAD_FORM_MOBILE: "open-lead-form-mobile-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        OPEN_LEAD_FORM_NEGOTIATE_PRICE_BUTTON: "open-lead-form-negotiate-price-button",
        OPEN_LEAD_FORM_PROPERTY_BOX: "open-lead-form-property-box-button",
        SIDEBAR_BUTTON_SHOW_PRICES: "sidebar-button-show-prices",
        CALL_BUTTON_MOBILE: "call-button-mobile",
        CONTACT_BAR_MOBILE: "contact-bar-mobile",
        CLOSE_ASK_FOR_FULL_OFFER_FORM_BUTTON: "close-ask-for-full-offer-form-button",
        CLOSE_LEAD_FORM_BUTTON: "close-lead-form-button",
        PHONE_MODAL: "phone-modal",
        PHONE_NUMBER_BUTTON: "phone-number-button",
        PROPERTY_BOX: (propertyId: string) => `property-${propertyId}`,
        PHONE_MODAL_SEND_BUTTON: "phone-modal-send-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PHONE_MODAL_NUMBER_PLACEHOLDER: "phone-modal-number-placeholder",
        PHONE_MODAL_SUCCESS_INFO: "phone-modal-success-info",
        PHONE_MODAL_GO_BACK_BUTTON: "phone-modal-go-back-button",
        OPEN_REGISTER_FORM_BUTTON: "open-register-form-button",
        REGISTER_FROM_HISTORY_PRICES: "register-from-history-prices",
        REGISTER_FORM_MODAL: "register-form-modal",
        CLOSE_REGISTER_FORM_BUTTON: "close-register-form-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        LEAD_FORM_MODAL: "lead-form-modal",

        // Page order: breadcrumbs → header → gallery → actions → navigation → key details → …
        OFFER_BREADCRUMBS_SECTION: "offer-breadcrumbs-section",
        OFFER_HEADER_SECTION: "offer-header-section",
        OFFER_NAME: "offer-name",
        OFFER_HEADER_VENDOR_NAME: "offer-vendor-name",
        OFFER_LOCATION: "offer-location",
        OFFER_PRICE: "offer-price",

        OFFER_GALLERY_SECTION: "offer-gallery-section",
        OPEN_GALLERY_BUTTON: "open-gallery-button",
        GALLERY_MODAL: "gallery-modal",
        SHOW_PRICES_FROM_GALLERY: "show-prices-from-gallery",
        DOWNLOAD_PLAN_FROM_GALLERY: "download-plan-from-gallery",

        OFFER_ACTIONS_SECTION_DESKTOP: "offer-actions-section-desktop",
        OFFER_ACTIONS_SECTION_MOBILE: "offer-actions-section-mobile",
        OPEN_MAP_BUTTON: "open-map-button",
        OPEN_PLAN_BUTTON: "open-plan-button",
        OPEN_CONSTRUCTION_GALLERY_BUTTON: "open-construction-gallery-button",
        DEVELOPER_REPORT_BUTTON: "developer-report-button",
        DEVELOPER_REPORT_MODAL: "developer-report-modal",

        OFFER_NAVIGATION_SECTION: "offer-navigation-section",
        OFFER_NAVIGATION_PROPERTIES_BUTTON: "offer-navigation-properties-button",
        OFFER_NAVIGATION_PROMOTIONS_BUTTON: "offer-navigation-promotions-button",
        OFFER_NAVIGATION_DESCRIPTION_BUTTON: "offer-navigation-description-button",
        OFFER_NAVIGATION_LOCATION_BUTTON: "offer-navigation-location-button",
        OFFER_NAVIGATION_CONTACT_BUTTON: "offer-navigation-contact-button",

        OFFER_KEY_DETAILS_SECTION: "offer-key-details-section",
        CONSTRUCTION_DEADLINE_VALUE: "construction-deadline-value",
        AREA_RANGE_VALUE: "area-range-value",
        ROOMS_RANGE_VALUE: "rooms-range-value",
        FLOORS_NUMBER_VALUE: "floors-number-value",
        BUILDINGS_NUMBER_VALUE: "buildings-number-value",
        FINISHING_STANDARD_VALUE: "finishing-standard-value",

        PROPERTIES_LIST_SECTION: "offer-properties-list-section",

        OFFER_GETHOME_SECTION: "offer-gethome-section",
        SEE_GETHOME_OFFERS_BUTTON: "see-gethome-offers-button",

        OFFER_AREA_MAP_SECTION: "offer-area-map-section",
        CHECK_TRAVEL_TIME_BUTTON: "check-travel-time-button",

        OFFER_PUBLIC_TRANSPORT_SECTION: "offer-public-transport-section",

        OFFER_CONSTRUCTION_PHOTOS_SECTION: "offer-construction-photos-section",
        SEE_CONSTRUCTION_STEPS_BUTTON: "see-construction-steps-button",

        OFFER_AMENITIES_SECTION: "offer-amenities-section",

        OFFER_DETAILS_SECTION: "offer-details-section",

        OFFER_CURRENT_OFFER_SECTION: "offer-current-offer-section",

        OFFER_DESCRIPTION_SECTION: "offer-description-section",
        READ_MORE_BUTTON: "read-more-button",

        OFFER_LOCATION_SECTION: "offer-location-section",

        OFFER_TIMESTAMPS_SECTION: "offer-timestamps-section",

        OFFER_SALES_OFFICE_INFO_SECTION: "offer-sales-office-info-section",
        VENDOR_LOGO: "vendor-logo",
        SALES_OFFICE_VENDOR_NAME: "sales-office-vendor-name",
        SALES_OFFICE_ADDRESS: "sales-office-address",
        SALES_OFFICE_OPENING_HOURS: "sales-office-opening-hours",
        SALES_OFFICE_PHONE_NUMBER: "sales-office-phone-number",
        OFFER_WEBSITE_LINK: "offer-website-link",
        OFFER_WEBSITE_URL: "offer-website-url",
        MAKE_AN_APPOINTMENT_BUTTON: "make-an-appointment-button",

        NEARBY_OFFERS_SECTION: "nearby-offers-section",
        NEARBY_OFFERS_TILE: "nearby-offers-tile",
        OFFER_TILE_OFFER_NAME: "offer-tile-offer-name",
        OPEN_PROMOTIONS_LEAD_FORM_BUTTON: "open-promotions-lead-form-button",

        // Modals (overlays)
        HOTLINE_DELAYED_MODAL: "hotline-delayed-modal",
        HOTLINE_DELAYED_MODAL_CLOSE_BUTTON: "hotline-delayed-modal-close-button",
        PROMOTION_DELAYED_MODAL: "promotion-delayed-modal",
        PROMOTION_DELAYED_MODAL_CLOSE_BUTTON: "promotion-delayed-modal-close-button",
        PROMOTION_DELAYED_MODAL_CTA: "promotion-delayed-modal-cta",

        HOTLINE_CHATBOT_MODAL: "hotline-chatbot-modal",
        HOTLINE_CHATBOT_MODAL_CLOSE_BUTTON: "hotline-chatbot-modal-close-button",
        HOTLINE_CHATBOT_MODAL_BUTTON: "hotline-chatbot-modal-button",
        HOTLINE_CHATBOT_MODAL_BUTTON_MOBILE: "hotline-chatbot-modal-button-mobile",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        HOTLINE_CHATBOT_MODAL_PHONE_BUTTON_MOBILE: "hotline-chatbot-modal-phone-button",
        HOTLINE_CONSULTANT_PRIMARY_CTA: "hotline-consultant-primary-cta"
    },
    LISTING_OFFER_BOX: {
        DESCRIPTION_ICON: "description-icon",
        PROPERTY_DESCRIPTION: "property-description",
        TOGGLE_MAP_BUTTON: "toggle-map-button",
        PROPERTY_VIEW_BUTTON: "property-view-button"
    },
    LEAD_FORM: {
        OFFER_LEAD_FORM: "offer-application-form",
        ASK_FOR_FULL_OFFER_FORM: "ask-for-full-offer-form",
        NEGOTIATION_FORM: "negotiation-form",
        PARKING_FORM: "parking-form",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PREMULTILEAD_CHECKBOX: "preMultiLead-checkbox",
        FORM_NAME_INPUT: "form-name-input",
        FORM_EMAIL_INPUT: "form-email-input",
        FORM_PHONE_INPUT: "form-phone-input",
        SEND_LEAD_BUTTON: "send-lead-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        CONFIRM_SEND_LEAD_BUTTON: "confirm-send-lead-button",
        PROPERTY_PRICE_REVEALED_MODAL: "property-price-revealed-modal",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        MULTILEAD_SUMMARY_HEADER: "multilead-summary-header",
        MULTILEAD_SUMMARY_TABLE: "multilead-summary-table",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        MULTILEAD_SUMMARY_ITEM: "multilead-summary-item",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        EXPAND_OFFER_BUTTON_MOBILE: "expand-offer-button-mobile",
        EMAIL_CONSENT_CHECKBOX: "email-consent-checkbox",
        PHONE_CONSENT_CHECKBOX: "phone-consent-checkbox",
        CONFIRM_LEAD_BUTTON: "confirm-lead-button",
        PROMOTION_LEAD_SUCCESS_MODAL: "promotion-lead-success-modal",
        PROMOTION_LEAD_SUCCESS_CLOSE_BUTTON: "promotion-lead-success-close-button",
        UNLOCK_CHOICE_MODAL: "unlock-choice-modal",
        UNLOCK_CHOICE_CONFIRM_BUTTON: "unlock-choice-confirm-button",
        UNLOCK_CHOICE_CLOSE_BUTTON: "unlock-choice-close-button",
        UNLOCK_CHOICE_LOADER: "unlock-choice-loader",
        UNLOCK_CHOICE_CONFIRMATION: "unlock-choice-confirmation",
        UNLOCK_CHOICE_PRICE_NEGOTIATION: "unlock-choice-price-negotiation",
        UNLOCK_CHOICE_PRICE_NEGOTIATION_CONFIRM_BUTTON: "unlock-choice-price-negotiation-confirm-button",
        UNLOCK_CHOICE_PRICE_NEGOTIATION_CLOSE_BUTTON: "unlock-choice-price-negotiation-close-button"
    },
    REGISTER_FORM: {
        GO_TO_LOGIN_FORM_BUTTON: "go-to-login-form-button"
    },
    LOGIN_FORM: {
        FORM_EMAIL_INPUT: "form-email-input",
        FORM_PASSWORD_INPUT: "form-password-input",
        LOGIN_BUTTON: "login-button"
    },
    PHONE_CONTACT_MODAL: {
        PHONE_CONTACT_MODAL_CLOSE_BUTTON: "phone-contact-modal-close-button"
    },
    PROPERTY_VIEW: {
        PROPERTY_BREADCRUMBS_SECTION: "property-breadcrumbs-section",
        PROPERTY_HEADER_SECTION: "property-header-section",
        PROPERTY_GALLERY_SECTION: "property-gallery-section",
        PROPERTY_PRICE: "property-price",
        PROPERTY_OFFER_NAME: "property-offer-name",
        PROPERTY_VENDOR_NAME: "property-vendor-name",
        PROPERTY_KEY_DETAILS_SECTION: "property-key-details-section",
        PROPERTY_ACTIONS_SECTION: "property-actions-section",
        VIEW_GALLERY_BUTTON: "property-view-gallery-button",
        PRICE_HISTORY_SECTION: "property-price-history-section",
        PRICE_HISTORY_SECTION_CONTENT: "property-price-history-section-content",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PRICE_HISTORY_REGISTER_BUTTON: "property-price-history-register-button",
        PRICE_HISTORY_LOGIN_BUTTON: "property-price-history-login-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PRICE_HISTORY_VIEW_BUTTON: "property-price-history-view-button",
        PRICE_HISTORY_ALERTS_BUTTON: "property-price-history-alerts-button",
        PRICE_HISTORY_PAYWALL_BACKDROP: "property-price-history-paywall-backdrop",
        BUILDING_AND_SURROUNDINGS: "property-building-and-surroundings",
        BOOKING_AND_FINANCE: "property-booking-and-finance",
        MORE_ABOUT_LOCATION: "property-more-about-location",
        INVESTMENT_LOCATION_SECTION: "property-investment-location-section",
        CHECK_ON_MAP_BUTTON: "property-check-on-map-button",
        OTHER_PROPERTIES_SECTION: "property-other-properties-section",
        DESCRIPTION_SECTION: "property-description-section",
        DESCRIPTION_READ_MORE_BUTTON: "property-description-read-more-button",
        SIDEBOX: "property-sidebox",
        REVEAL_PRICE_BUTTON: "property-reveal-price-button",
        PARKING_LEAD_BUTTON: "property-parking-lead-button",
        VENDOR_REPORT_SECTION: "property-vendor-report-section",
        VENDOR_REPORT_BUTTON: "property-vendor-report-button"
    }
};
export const OFFER_TEST_IDS = {
    OFFER_VIEW: {
        // Lead / register / phone (header & modals)
        OPEN_LEAD_FORM_HEADING: "open-lead-form-heading-button",
        OPEN_LEAD_FORM_DEVELOPER_BOX: "open-lead-form-developer-button",
        OPEN_LEAD_FORM_MOBILE: "open-lead-form-mobile-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        OPEN_LEAD_FORM_NEGOTIATE_PRICE_BUTTON: "open-lead-form-negotiate-price-button",
        OPEN_LEAD_FORM_PROPERTY_BOX: "open-lead-form-property-box-button",
        SIDEBAR_BUTTON_SHOW_PRICES: "sidebar-button-show-prices",
        CALL_BUTTON_MOBILE: "call-button-mobile",
        CONTACT_BAR_MOBILE: "contact-bar-mobile",
        CLOSE_ASK_FOR_FULL_OFFER_FORM_BUTTON: "close-ask-for-full-offer-form-button",
        CLOSE_LEAD_FORM_BUTTON: "close-lead-form-button",
        PHONE_MODAL: "phone-modal",
        PHONE_NUMBER_BUTTON: "phone-number-button",
        PROPERTY_BOX: (propertyId: string) => `property-${propertyId}`,
        PHONE_MODAL_SEND_BUTTON: "phone-modal-send-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PHONE_MODAL_NUMBER_PLACEHOLDER: "phone-modal-number-placeholder",
        PHONE_MODAL_SUCCESS_INFO: "phone-modal-success-info",
        PHONE_MODAL_GO_BACK_BUTTON: "phone-modal-go-back-button",
        OPEN_REGISTER_FORM_BUTTON: "open-register-form-button",
        REGISTER_FROM_HISTORY_PRICES: "register-from-history-prices",
        REGISTER_FORM_MODAL: "register-form-modal",
        CLOSE_REGISTER_FORM_BUTTON: "close-register-form-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        LEAD_FORM_MODAL: "lead-form-modal",

        // Page order: breadcrumbs → header → gallery → actions → navigation → key details → …
        OFFER_BREADCRUMBS_SECTION: "offer-breadcrumbs-section",
        OFFER_HEADER_SECTION: "offer-header-section",
        OFFER_NAME: "offer-name",
        OFFER_HEADER_VENDOR_NAME: "offer-vendor-name",
        OFFER_LOCATION: "offer-location",
        OFFER_PRICE: "offer-price",

        OFFER_GALLERY_SECTION: "offer-gallery-section",
        OPEN_GALLERY_BUTTON: "open-gallery-button",
        GALLERY_MODAL: "gallery-modal",
        SHOW_PRICES_FROM_GALLERY: "show-prices-from-gallery",
        DOWNLOAD_PLAN_FROM_GALLERY: "download-plan-from-gallery",

        OFFER_ACTIONS_SECTION_DESKTOP: "offer-actions-section-desktop",
        OFFER_ACTIONS_SECTION_MOBILE: "offer-actions-section-mobile",
        OPEN_MAP_BUTTON: "open-map-button",
        OPEN_PLAN_BUTTON: "open-plan-button",
        OPEN_CONSTRUCTION_GALLERY_BUTTON: "open-construction-gallery-button",
        DEVELOPER_REPORT_BUTTON: "developer-report-button",
        DEVELOPER_REPORT_MODAL: "developer-report-modal",

        OFFER_NAVIGATION_SECTION: "offer-navigation-section",
        OFFER_NAVIGATION_PROPERTIES_BUTTON: "offer-navigation-properties-button",
        OFFER_NAVIGATION_PROMOTIONS_BUTTON: "offer-navigation-promotions-button",
        OFFER_NAVIGATION_DESCRIPTION_BUTTON: "offer-navigation-description-button",
        OFFER_NAVIGATION_LOCATION_BUTTON: "offer-navigation-location-button",
        OFFER_NAVIGATION_CONTACT_BUTTON: "offer-navigation-contact-button",

        OFFER_KEY_DETAILS_SECTION: "offer-key-details-section",
        CONSTRUCTION_DEADLINE_VALUE: "construction-deadline-value",
        AREA_RANGE_VALUE: "area-range-value",
        ROOMS_RANGE_VALUE: "rooms-range-value",
        FLOORS_NUMBER_VALUE: "floors-number-value",
        BUILDINGS_NUMBER_VALUE: "buildings-number-value",
        FINISHING_STANDARD_VALUE: "finishing-standard-value",

        PROPERTIES_LIST_SECTION: "offer-properties-list-section",

        OFFER_GETHOME_SECTION: "offer-gethome-section",
        SEE_GETHOME_OFFERS_BUTTON: "see-gethome-offers-button",

        OFFER_AREA_MAP_SECTION: "offer-area-map-section",
        CHECK_TRAVEL_TIME_BUTTON: "check-travel-time-button",

        OFFER_PUBLIC_TRANSPORT_SECTION: "offer-public-transport-section",

        OFFER_CONSTRUCTION_PHOTOS_SECTION: "offer-construction-photos-section",
        SEE_CONSTRUCTION_STEPS_BUTTON: "see-construction-steps-button",

        OFFER_AMENITIES_SECTION: "offer-amenities-section",

        OFFER_DETAILS_SECTION: "offer-details-section",

        OFFER_CURRENT_OFFER_SECTION: "offer-current-offer-section",

        OFFER_DESCRIPTION_SECTION: "offer-description-section",
        READ_MORE_BUTTON: "read-more-button",

        OFFER_LOCATION_SECTION: "offer-location-section",

        OFFER_TIMESTAMPS_SECTION: "offer-timestamps-section",

        OFFER_SALES_OFFICE_INFO_SECTION: "offer-sales-office-info-section",
        VENDOR_LOGO: "vendor-logo",
        SALES_OFFICE_VENDOR_NAME: "sales-office-vendor-name",
        SALES_OFFICE_ADDRESS: "sales-office-address",
        SALES_OFFICE_OPENING_HOURS: "sales-office-opening-hours",
        SALES_OFFICE_PHONE_NUMBER: "sales-office-phone-number",
        OFFER_WEBSITE_LINK: "offer-website-link",
        OFFER_WEBSITE_URL: "offer-website-url",
        MAKE_AN_APPOINTMENT_BUTTON: "make-an-appointment-button",

        NEARBY_OFFERS_SECTION: "nearby-offers-section",
        NEARBY_OFFERS_TILE: "nearby-offers-tile",
        OFFER_TILE_OFFER_NAME: "offer-tile-offer-name",
        OPEN_PROMOTIONS_LEAD_FORM_BUTTON: "open-promotions-lead-form-button",

        // Modals (overlays)
        HOTLINE_DELAYED_MODAL: "hotline-delayed-modal",
        HOTLINE_DELAYED_MODAL_CLOSE_BUTTON: "hotline-delayed-modal-close-button",
        PROMOTION_DELAYED_MODAL: "promotion-delayed-modal",
        PROMOTION_DELAYED_MODAL_CLOSE_BUTTON: "promotion-delayed-modal-close-button",
        PROMOTION_DELAYED_MODAL_CTA: "promotion-delayed-modal-cta",

        HOTLINE_CHATBOT_MODAL: "hotline-chatbot-modal",
        HOTLINE_CHATBOT_MODAL_CLOSE_BUTTON: "hotline-chatbot-modal-close-button",
        HOTLINE_CHATBOT_MODAL_BUTTON: "hotline-chatbot-modal-button",
        HOTLINE_CHATBOT_MODAL_BUTTON_MOBILE: "hotline-chatbot-modal-button-mobile",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        HOTLINE_CHATBOT_MODAL_PHONE_BUTTON_MOBILE: "hotline-chatbot-modal-phone-button",
        HOTLINE_CONSULTANT_PRIMARY_CTA: "hotline-consultant-primary-cta"
    },
    LISTING_OFFER_BOX: {
        DESCRIPTION_ICON: "description-icon",
        PROPERTY_DESCRIPTION: "property-description",
        TOGGLE_MAP_BUTTON: "toggle-map-button",
        PROPERTY_VIEW_BUTTON: "property-view-button"
    },
    LEAD_FORM: {
        OFFER_LEAD_FORM: "offer-application-form",
        ASK_FOR_FULL_OFFER_FORM: "ask-for-full-offer-form",
        NEGOTIATION_FORM: "negotiation-form",
        PARKING_FORM: "parking-form",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PREMULTILEAD_CHECKBOX: "preMultiLead-checkbox",
        FORM_NAME_INPUT: "form-name-input",
        FORM_EMAIL_INPUT: "form-email-input",
        FORM_PHONE_INPUT: "form-phone-input",
        SEND_LEAD_BUTTON: "send-lead-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        CONFIRM_SEND_LEAD_BUTTON: "confirm-send-lead-button",
        PROPERTY_PRICE_REVEALED_MODAL: "property-price-revealed-modal",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        MULTILEAD_SUMMARY_HEADER: "multilead-summary-header",
        MULTILEAD_SUMMARY_TABLE: "multilead-summary-table",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        MULTILEAD_SUMMARY_ITEM: "multilead-summary-item",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        EXPAND_OFFER_BUTTON_MOBILE: "expand-offer-button-mobile",
        EMAIL_CONSENT_CHECKBOX: "email-consent-checkbox",
        PHONE_CONSENT_CHECKBOX: "phone-consent-checkbox",
        CONFIRM_LEAD_BUTTON: "confirm-lead-button",
        PROMOTION_LEAD_SUCCESS_MODAL: "promotion-lead-success-modal",
        PROMOTION_LEAD_SUCCESS_CLOSE_BUTTON: "promotion-lead-success-close-button",
        UNLOCK_CHOICE_MODAL: "unlock-choice-modal",
        UNLOCK_CHOICE_CONFIRM_BUTTON: "unlock-choice-confirm-button",
        UNLOCK_CHOICE_CLOSE_BUTTON: "unlock-choice-close-button",
        UNLOCK_CHOICE_LOADER: "unlock-choice-loader",
        UNLOCK_CHOICE_CONFIRMATION: "unlock-choice-confirmation",
        UNLOCK_CHOICE_PRICE_NEGOTIATION: "unlock-choice-price-negotiation",
        UNLOCK_CHOICE_PRICE_NEGOTIATION_CONFIRM_BUTTON: "unlock-choice-price-negotiation-confirm-button",
        UNLOCK_CHOICE_PRICE_NEGOTIATION_CLOSE_BUTTON: "unlock-choice-price-negotiation-close-button"
    },
    REGISTER_FORM: {
        GO_TO_LOGIN_FORM_BUTTON: "go-to-login-form-button"
    },
    LOGIN_FORM: {
        FORM_EMAIL_INPUT: "form-email-input",
        FORM_PASSWORD_INPUT: "form-password-input",
        LOGIN_BUTTON: "login-button"
    },
    PHONE_CONTACT_MODAL: {
        PHONE_CONTACT_MODAL_CLOSE_BUTTON: "phone-contact-modal-close-button"
    },
    PROPERTY_VIEW: {
        PROPERTY_BREADCRUMBS_SECTION: "property-breadcrumbs-section",
        PROPERTY_HEADER_SECTION: "property-header-section",
        PROPERTY_GALLERY_SECTION: "property-gallery-section",
        PROPERTY_PRICE: "property-price",
        PROPERTY_OFFER_NAME: "property-offer-name",
        PROPERTY_VENDOR_NAME: "property-vendor-name",
        PROPERTY_KEY_DETAILS_SECTION: "property-key-details-section",
        PROPERTY_ACTIONS_SECTION: "property-actions-section",
        VIEW_GALLERY_BUTTON: "property-view-gallery-button",
        PRICE_HISTORY_SECTION: "property-price-history-section",
        PRICE_HISTORY_SECTION_CONTENT: "property-price-history-section-content",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PRICE_HISTORY_REGISTER_BUTTON: "property-price-history-register-button",
        PRICE_HISTORY_LOGIN_BUTTON: "property-price-history-login-button",
        // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
        PRICE_HISTORY_VIEW_BUTTON: "property-price-history-view-button",
        PRICE_HISTORY_ALERTS_BUTTON: "property-price-history-alerts-button",
        PRICE_HISTORY_PAYWALL_BACKDROP: "property-price-history-paywall-backdrop",
        BUILDING_AND_SURROUNDINGS: "property-building-and-surroundings",
        BOOKING_AND_FINANCE: "property-booking-and-finance",
        MORE_ABOUT_LOCATION: "property-more-about-location",
        INVESTMENT_LOCATION_SECTION: "property-investment-location-section",
        CHECK_ON_MAP_BUTTON: "property-check-on-map-button",
        OTHER_PROPERTIES_SECTION: "property-other-properties-section",
        DESCRIPTION_SECTION: "property-description-section",
        DESCRIPTION_READ_MORE_BUTTON: "property-description-read-more-button",
        SIDEBOX: "property-sidebox",
        REVEAL_PRICE_BUTTON: "property-reveal-price-button",
        PARKING_LEAD_BUTTON: "property-parking-lead-button",
        VENDOR_REPORT_SECTION: "property-vendor-report-section",
        VENDOR_REPORT_BUTTON: "property-vendor-report-button"
    }
};
